// Typelizer digest 4d191b4c39f6fdd1f46a7c4f7c1d8690
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /fields */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/fields', {}, options),
    method: 'post',
  }),

  /** GET /fields/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/fields/:id', params, options),
    method: 'get',
  }),

  /** PATCH /fields/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/fields/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /fields/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/fields/:id', params, options),
    method: 'delete',
  }),
}
